import { useTheme } from 'context/ThemeContext';
import { ParticlesProvider } from '@tsparticles/react';

import TetEffect from './TetEffect';
import NoelEffect from './NoelEffect';
import FlowerEffect from './FlowerEffect';
import { initParticlesEngine } from './particlesEngine';
import NationalDayEffect from './NationalDayEffect';
import CultureDayEffect from './CultureDayEffect';
export default function ThemeEffectManager() {
    const { theme } = useTheme();

    let effect = null;
    switch (theme) {
        case 'nationalDay':
            effect = <NationalDayEffect />;
            break;
        case 'tet':
            effect = <TetEffect />;
            break;
        case 'noel':
            effect = <NoelEffect />;
            break;
        case 'womenDay':
            effect = <FlowerEffect />;
            break;
        case 'cultureDay':
            effect = <CultureDayEffect />;
            break;
        default:
            return null;
    }

    return (
        <ParticlesProvider init={initParticlesEngine}>
            {effect}
        </ParticlesProvider>
    );
}
